import { formatName } from './formatName.mjs';
import { UnicodeCharacterSet } from './constants.mjs';
import { identifyScripts } from './utilities/identifyScripts.mjs';
import { getGraphemes } from './utilities/getGraphemes.mjs';

function abbreviateName({
  name,
  locale,
  options
}) {
  var _tryAbbreviateName;

  return (_tryAbbreviateName = tryAbbreviateName({
    givenName: name.givenName,
    familyName: name.familyName,
    idealMaxLength: options === null || options === void 0 ? void 0 : options.idealMaxLength
  })) !== null && _tryAbbreviateName !== void 0 ? _tryAbbreviateName : formatName({
    name,
    locale
  });
}
function tryAbbreviateName({
  givenName,
  familyName,
  idealMaxLength = 3
}) {
  if (!givenName && !familyName) {
    return undefined;
  }

  const givenNameTrimmed = givenName === null || givenName === void 0 ? void 0 : givenName.trim();
  const familyNameTrimmed = familyName === null || familyName === void 0 ? void 0 : familyName.trim();
  const combinedName = [givenNameTrimmed, familyNameTrimmed].join('');

  if (new RegExp(`${UnicodeCharacterSet.Punctuation}|\\s`).test(combinedName)) {
    return undefined;
  }

  const scripts = identifyScripts(combinedName);

  if (scripts.length !== 1) {
    return undefined;
  }

  const script = scripts[0];

  switch (script) {
    case UnicodeCharacterSet.Latin:
      return [givenNameTrimmed === null || givenNameTrimmed === void 0 ? void 0 : givenNameTrimmed[0], familyNameTrimmed === null || familyNameTrimmed === void 0 ? void 0 : familyNameTrimmed[0]].join('');

    case UnicodeCharacterSet.Han:
    case UnicodeCharacterSet.Katakana:
    case UnicodeCharacterSet.Hiragana:
      return familyNameTrimmed;

    case UnicodeCharacterSet.Hangul:
      if (givenNameTrimmed) {
        if (givenNameTrimmed.length > idealMaxLength) {
          var _getGraphemes;

          return (_getGraphemes = getGraphemes({
            text: givenNameTrimmed,
            locale: 'ko'
          })) === null || _getGraphemes === void 0 ? void 0 : _getGraphemes[0];
        } else {
          return givenNameTrimmed;
        }
      } else {
        return familyNameTrimmed;
      }

    case UnicodeCharacterSet.Thai:
      if (givenNameTrimmed) {
        var _getGraphemes2;

        return (_getGraphemes2 = getGraphemes({
          text: givenNameTrimmed,
          locale: 'th'
        })) === null || _getGraphemes2 === void 0 ? void 0 : _getGraphemes2[0];
      } else {
        var _getGraphemes3;

        return (_getGraphemes3 = getGraphemes({
          text: familyNameTrimmed,
          locale: 'th'
        })) === null || _getGraphemes3 === void 0 ? void 0 : _getGraphemes3[0];
      }

    default:
      return undefined;
  }
}

export { abbreviateName, tryAbbreviateName };
